import { global_stylist_module } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { StylistModuleProps } from './StylistModule';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';

export const stylistModuleSchema =
  global_stylist_module.transform<StylistModuleProps>(data => {
    const image = getCloudinaryImageFields({
      alt: data.image.alt_text,
      cloudinaryField: data.image.src,
      shouldUseV2: true,
    });

    return {
      header: data.header,
      description: data.description,
      testimonials: data.testimonials,
      image,
    };
  });
